import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse
} from 'shards-react';

import './_navbar.css';

class NavBar extends Component {
  constructor(props) {
    super(props);

    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.toggleNavbar = this.toggleNavbar.bind(this);

    this.state = {
      dropdownOpen: false,
      collapseOpen: false
    };
  }

  toggleDropdown() {
    const { dropdownOpen } = this.state;
    this.setState({
      dropdownOpen: !dropdownOpen
    });
  }

  toggleNavbar() {
    const { collapseOpen } = this.state;
    this.setState({
      collapseOpen: !collapseOpen
    });
  }

  render() {
    const { labs, projectSubmission } = this.props;
    const { collapseOpen, dropdownOpen } = this.state;
    return (
      <Navbar type="dark" theme="primary" expand="md">
        <NavbarBrand>
          <Link to="/">CS 390VR</Link>
        </NavbarBrand>
        <NavbarToggler onClick={this.toggleNavbar} />

        <Collapse open={collapseOpen} navbar>
          <Nav navbar>
            <Dropdown open={dropdownOpen} toggle={this.toggleDropdown}>
              <DropdownToggle nav caret>
                Labs
              </DropdownToggle>
              <DropdownMenu>
                {labs.map(lab => (
                  <DropdownItem>
                    <Link to={lab.route}>{lab.name}</Link>
                  </DropdownItem>
                ))}
                <DropdownItem>
                  <a href={projectSubmission}>Submit Final Project</a>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <NavItem>
              <NavLink active>
                <Link to="/syllabus">Syllabus</Link>
              </NavLink>
            </NavItem>
            <NavItem />
            <NavItem>
              <NavLink active>
                <Link to="/slides">Slides</Link>
              </NavLink>
            </NavItem>
            <NavItem />
            <NavItem>
              <NavLink active>
              <Link to="/pastprojects">Project Archive</Link>
              </NavLink>
            </NavItem>
            <NavItem />
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}

export default NavBar;
